<template>
  <div>
    <v-select
      v-model="localValue"
      :items="languages"
      item-text="name"
      item-value="code"
      :label="label"
      outlined
      dense
      :loading="isUpdating"
      :error="hasError"
      :success="showSuccess"
      @change="onInput"
    />
  </div>
</template>

<script>
import ProductInfoFieldMixin from '@/mixins/ProductInfoFieldMixin';
import { bookLanguages } from '@/utils/Const.js';

export default {
  name: 'LocalBookLanguageSelect',
  mixins: [ProductInfoFieldMixin],
  props: {
    label: {
      type: String,
      default: 'Language'
    }
  },
  data() {
    return {
      languages: [
        { code: null, name: 'Please select a language' },
        ...bookLanguages
      ]
    };
  },
};
</script>